import { TextInput, TextInputProps } from './text-input';
import type { FactoryOpts } from 'imask';
import { forwardRef, useCallback, useEffect } from 'react';
import { useIMask } from 'react-imask';

export interface MaskedTextInputProps extends Omit<TextInputProps, 'onChange' | 'value'> {
  mask: FactoryOpts;
  value?: string;
  onChange?: (value: string) => void;
}

export const MaskedTextInput = forwardRef<HTMLInputElement, MaskedTextInputProps>(
  ({ mask, value = '', onChange, ...textInputProps }, ref) => {
    const handleAccept = useCallback(
      (val: string) => {
        onChange?.(val);
      },
      [onChange]
    );

    const { ref: maskRef, setValue } = useIMask(mask, {
      onAccept: handleAccept,
      defaultValue: value
    });

    useEffect(() => {
      setValue(value);
    }, [value, setValue]);

    return (
      <TextInput
        ref={(node) => {
          (maskRef as React.MutableRefObject<HTMLInputElement | null>).current = node;
          if (typeof ref === 'function') {
            ref(node);
          } else if (ref) {
            (ref as React.MutableRefObject<HTMLInputElement | null>).current = node;
          }
        }}
        {...textInputProps}
      />
    );
  }
);

MaskedTextInput.displayName = 'MaskedTextInput';
